import { type Car as LdJsonCar, type WithContext } from 'schema-dts';
import type { Car } from '../../../_types/Car';
import checkUndefinedNullOrEmpty from '../../../utils/tools/checkUndefinedNullOrEmpty';
import checkUndefinedOrNull from '../../../utils/tools/checkUndefinedOrNull';
import type { MetaData } from '../../../vars';

export default function ldJsonCar(car: Car<false>, meta: MetaData): WithContext<LdJsonCar> {
    return {
        '@context': 'https://schema.org',
        '@id': meta?.url,
        '@type': 'Car',

        // Required fields
        'brand': {
            '@type': 'Brand',
            'name': car?.hersteller,
        },
        'itemCondition': car?.typ === 'Neufahrzeug' ? 'NewCondition' : 'UsedCondition',
        'mileageFromOdometer':
            car?.typ !== 'Neufahrzeug' && !checkUndefinedNullOrEmpty(car?.km) && car?.km > 0
                ? {
                      '@type': 'QuantitativeValue',
                      'value': car?.km,
                      'unitCode': 'KMT',
                  }
                : undefined,
        'model': car?.modell,
        'offers': {
            '@type': 'Offer',
            'availability': 'InStock' /* (
        (!checkUndefinedOrNull(car?.verfuegbarAb) && isBefore(new Date(), car?.verfuegbarAb)) || (!checkUndefinedNullOrEmpty(car?.lieferzeit) && car?.lieferzeit > 5)
            ? 'PreOrder'
            : 'InStock'
    ), */,
            'price': car?.preis?.vk,
            'priceCurrency': 'EUR',
        },
        'vehicleIdentificationNumber': car?.vin,
        'vehicleModelDate': !checkUndefinedOrNull(car?.modelljahr) ? new Date(car?.modelljahr)?.toISOString() : undefined,

        // Recommended fields
        'bodyType': car?.aufbau,
        'color': car?.farbe?.name || car?.farbe?.grund,
        'driveWheelConfiguration':
            car?.antrieb === 'Frontantrieb'
                ? 'FrontWheelDriveConfiguration'
                : car?.antrieb === 'Heckantrieb'
                  ? 'RearWheelDriveConfiguration'
                  : car?.antrieb === 'Allradantrieb'
                    ? 'AllWheelDriveConfiguration'
                    : undefined,
        'image': car?.bilder?.url,
        'name': car?.name,
        'numberOfDoors': car?.tueren,
        'url': meta?.url,
        'vehicleConfiguration': car?.design,
        'vehicleEngine': {
            '@type': 'EngineSpecification',
            'engineDisplacement': {
                '@type': 'QuantitativeValue',
                'value': car?.engine?.hubraum,
                'unitCode': 'CMQ',
            },
            'enginePower': {
                '@type': 'QuantitativeValue',
                'value': car?.engine?.leistungKwNumbered,
                'unitCode': 'KWT',
            },
            'engineType': car?.engine?.motor,
            'fuelType': car?.engine?.kraftstoff,
        },
        'vehicleInteriorColor': car?.farbe_innen?.name || car?.farbe_innen?.grund,
        'vehicleInteriorType': car?.polster,
        'vehicleSeatingCapacity': car?.sitze,
        'vehicleTransmission': car?.getriebe,

        // Other fields
        'additionalProperty': car?.lHighlights?.map((h) => ({
            '@type': 'PropertyValue',
            'name': 'Ausstattungs-Highlight',
            'value': h,
        })),
        'dateVehicleFirstRegistered': car?.ez?.toISOString(),
        'emissionsCO2': car?.verbrauchNumbered?.emission,
        'fuelConsumption': {
            '@type': 'QuantitativeValue',
            'unitText': 'l/100 km',
            'value': car?.verbrauchNumbered?.combined,
        },
        'meetsEmissionStandard': car?.verbrauch?.envkv === true ? 'yes' : 'no',
        'numberOfPreviousOwners': car?.vorbesitzer,
        'productID': car?.ident,
    };
}
